class FeedService {

    constructor(SERVICE_LOCATIONS, $http, $q, $rootScope) {

        return {

            getFeed: (feedId) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + 'feed/' + feedId)
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            getFeedItems: (feedId, revisionId, page, perPage, query, fields) => {
                let deferred = $q.defer();
                let params = [
                    'revision=' + revisionId,
                    'page=' + page,
                    'perPage=' + perPage,
                    'query=' + query,
                ];

                if(!!fields) {
                    'fields=' + fields
                }

                $http.get(SERVICE_LOCATIONS.CPM_API + 'feed/' + feedId + '/items?' + params.join('&'), {errorMessage: 'Failed to load feed items.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            getFeedFields: (feedId, revisionId) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + 'feed/' + feedId + '/fields', {errorMessage: 'Failed to load feed fields.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            getFeedMappings: (feedId, revisionId) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + 'feed/' + feedId + '/mappings', {errorMessage: 'Failed to load feed mappings.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            saveFeedMappings: (feedId, fields) => {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + 'feed/' + feedId + '/mappings', fields, {errorMessage: 'Failed to save feed mappings.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            regenerateFeedMappings: (feedId) => {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + 'feed/' + feedId + '/mappings/regenerate', null, {errorMessage: 'Failed to regenerate feed mappings.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            deleteFeedMappings: (feedId) => {
                let deferred = $q.defer();
                $http.delete(SERVICE_LOCATIONS.CPM_API + 'feed/' + feedId + '/mappings/delete', {errorMessage: 'Failed to delete feed mappings.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            uploadUrl: (feed, url, publish) => {
                let deferred = $q.defer();
                var data = {
                    url: url,
                    options: publish
                };

                $http.post(SERVICE_LOCATIONS.CPM_API + 'feed/' + feed.id + '/upload-url', data, {errorMessage: 'Upload of feed data from URL failed.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            uploadFeed: (feed, file, options) => {
                let deferred = $q.defer();
                let data = new FormData();
                data.append('file', file);
                data.append('options', options);

                $http.post(SERVICE_LOCATIONS.CPM_API + 'feed/' + feed.id + '/upload', data, {
                        errorMessage: 'Feed upload failed.',
                        transformRequest: angular.identity,
                        headers: {
                            'Content-Type': undefined
                        }
                    })
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            getRevisions: (feedId) => {
                let deferred = $q.defer();
                $http.get(SERVICE_LOCATIONS.CPM_API + 'feed/' + feedId + '/revisions', {errorMessage: 'Failed to load feed revisions.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            publishRevision: (feedId, revisionId) => {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + 'feed/' + feedId + '/publish?revision=' + revisionId, null, {errorMessage: 'Publishing failed.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            },

            stageRevision: (feedId, revisionId) => {
                let deferred = $q.defer();
                $http.post(SERVICE_LOCATIONS.CPM_API + 'feed/' + feedId + '/stage?revision=' + revisionId, null, {errorMessage: 'Staging failed.'})
                    .then(
                        response => deferred.resolve(response),
                        err => {
                            if (err.status === 401) {
                                $rootScope.$emit('accessDenied');
                            } else {
                                deferred.reject(err);
                            }
                        }
                    );
                return deferred.promise;
            }

        };

    }

}

angular.module('cpm')
    .service('$feedService', ['SERVICE_LOCATIONS', '$http', '$q', '$rootScope', FeedService]);
